module.exports = __webpack_public_path__ + "public/files/img/review.d6fe8761.png";